import { FC, useMemo } from 'react';
import cx from 'classnames';
import blacklistIconSrc from '@/assets/icons/black-list.svg';
import styles from './RiskIndicatorBlackList.module.sass';
import { AmlFlowEnum } from '@/api';
import { isFlowLite } from '@/helpers';

interface RiskIndicatorBlackListProps {
  note: string;
  className?: string;
  amlFlow?: AmlFlowEnum;
}

const RiskIndicatorBlackList: FC<RiskIndicatorBlackListProps> = ({
  note,
  className,
  amlFlow,
}) => {
  const classes = cx(styles.risk, className);
  const from = useMemo(() => (isFlowLite(amlFlow) ? 'Low' : '0'), [amlFlow]);
  const to = useMemo(() => (isFlowLite(amlFlow) ? 'High' : '100'), [amlFlow]);

  return (
    <div className={classes}>
      <div className={styles.inner}>
        <div className={styles.gray} />
      </div>

      <div className={styles['level-white']}>
        <div className={styles.value}>
          <img src={blacklistIconSrc} alt="" className={styles.value__icon} />
          <div className={styles.value__note}>{note}</div>
        </div>
      </div>

      <div className={styles.from}>{from}</div>
      <div className={styles.to}>{to}</div>
    </div>
  );
};

export default RiskIndicatorBlackList;
